import React, { useEffect, useState } from 'react';
import { Table, Container } from 'react-bootstrap';

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const formatTxnDate = (value) => {
  if (value == null || value === "") return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  const dd = String(d.getDate()).padStart(2, "0");
  let hours = d.getHours();
  const mins = String(d.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${dd}-${months[d.getMonth()]}-${d.getFullYear()} ${String(hours).padStart(2, "0")}:${mins} ${ampm}`;
};

const money = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

const TransactionDetails = (props) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const wallet = props.data?.eWalletTransactions || [];
    setRows(wallet);
  }, [props.data]);

  return (
    <Container fluid style={{ padding: '0', marginTop: 16 }}>
      <h5 style={{ marginBottom: 12 }}>Transactions</h5>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Date</th>
            <th>Debit</th>
            <th>Credit</th>
            <th>Balance</th>
            <th>Status</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {rows.length ? rows.map((data, index) => (
            <tr key={index}>
              <td>{formatTxnDate(data.tableEntryDate)}</td>
              <td>{data.debit ? money(data.amount) : "0"}</td>
              <td>{data.credit ? money(data.amount) : "0"}</td>
              <td>{money(data.balance)}</td>
              <td>{(data.status || "-").toUpperCase()}</td>
              <td>{data.message?.trim() ? data.message : "-"}</td>
            </tr>
          )) : (
            <tr>
              <td colSpan={6}>No Transactions Found</td>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
};

export default TransactionDetails;
